module.exports = __webpack_public_path__ + "media/images/flags/1x1/per-c486e4083a06d0c610432c3c228a93cf.svg";